import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Box, Flex } from 'core/components';
import IpFilter from 'app/views/serviceProvider/marketIntel/Filter/IpFilter';
import MarketFilter from 'app/views/serviceProvider/marketIntel/Filter/MarketFilter';
import CustomerTypeFilter from 'app/views/serviceProvider/marketIntel/Filter/CustomerTypeFilter';

@observer
export default class RanksExportOptions extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    filterValues: PropTypes.object
  };

  static defaultProps = {
    disabled: false,
    onChange: () => {},
    filterValues: {}
  };

  state = {
    ip: 'v4',
    id: 'planet$earth',
    rank_type: 0
  };

  componentDidMount() {
    const { filterValues } = this.props;
    const ip = filterValues.ip || 'v4';
    const id = filterValues.id || 'planet$earth';
    const rank_type =
      typeof filterValues.rank_type === 'number' ? filterValues.rank_type : parseInt(filterValues.rank_type || 0, 10);
    this.setState({ ip, id, rank_type }, () => this.handleChange());
  }

  componentDidUpdate(prevProps, prevState) {
    const { ip, id, rank_type } = this.state;
    if (prevState.ip !== ip || prevState.id !== id || prevState.rank_type !== rank_type) {
      this.handleChange();
    }
  }

  handleChange = () => {
    const { onChange } = this.props;
    const { ip, id, rank_type } = this.state;
    onChange({ ip, id, rank_type });
  };

  render() {
    const { disabled } = this.props;
    const { ip, rank_type, id } = this.state;

    return (
      <Box mt={-1} mb={2}>
        <Flex gap={2} alignItems="center" flexWrap="wrap">
          <IpFilter
            defaultFilter={{ ip }}
            onChange={(change) => this.setState({ ip: change.ip?.value || change.ip })}
            disabled={disabled}
          />
          <MarketFilter fieldValue={id} onChange={(m) => this.setState({ id: m.id })} disabled={disabled} />
          <CustomerTypeFilter
            defaultFilter={{ rank_type }}
            onChange={(change) => this.setState({ rank_type: change.rank_type?.value ?? change.rank_type })}
            disabled={disabled}
          />
        </Flex>
      </Box>
    );
  }
}
